import { render, staticRenderFns } from "./PCProductsUpload.vue?vue&type=template&id=76bcc8ec&"
import script from "./PCProductsUpload.vue?vue&type=script&lang=js&"
export * from "./PCProductsUpload.vue?vue&type=script&lang=js&"
import style0 from "./PCProductsUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports